export default __webpack_public_path__ + "static/media/x-circle.c5d4fb85.svg";